import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseGetAgentCall } from 'entities/AICalling/api/types'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export class CallingContactListItem extends RowBase<IResponseGetAgentCall> {
  constructor(origin: IResponseGetAgentCall, readonly entities: IEntitiesStore) {
    super(origin)

    makeObservableRowBase(this, {
      id: computed,
      contact: computed,
      call: computed,
      number: computed,
      callDuration: computed,
      audioUrl: computed,
      created_at: computed,
      inbox: computed,
      inboxName: computed,
      inboxNumber: computed,
    })
  }

  get id() {
    return this.origin.id
  }

  get contact() {
    return {
      ...this.origin.contact,
      avatarInfo: {
        image: this.origin.contact?.photo_url || '',
        color: this.origin.contact?.color || '',
        firstName: this.origin.contact?.name || '',
        number: this.origin.contact?.number,
      },
      full_name: this.origin.contact?.name,
      isDisabled: false,
    }
  }
  get call() {
    return this.origin.call
  }

  get number() {
    return this.contact?.number
  }
  get callDuration() {
    return this.call.duration || 0
  }
  get audioUrl() {
    return this.call.record_url
  }
  get created_at() {
    return this.call.created_at
  }

  get inbox() {
    return this.origin.inbox
  }

  get inboxName() {
    return this.inbox?.name || ''
  }

  get inboxNumber() {
    return this.inbox?.number?.formatted_number
  }
}
